/* global translations */
/* eslint import/no-unresolved: 2 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Webcam from 'react-webcam';
import get from 'lodash/get';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';

class VerificationWebcam extends Component {
  state = {
    webcamStatus: null,
    webcamDimensions: null,
  };

  webcamVideo = React.createRef();

  componentDidUpdate() {
    const webcamVideo = this.webcamVideo.current;
    if (!webcamVideo || !webcamVideo.video) {
      return;
    }

    const { webcamDimensions } = this.state;
    const { clientHeight, clientWidth } = webcamVideo.video;

    if (webcamDimensions
      && webcamDimensions.height === clientHeight
      && webcamDimensions.width === clientWidth
    ) {
      return;
    }

    this.setState({
      webcamDimensions: {
        width: clientWidth,
        height: clientHeight,
      },
    });
  }

  setWebcamStatus(webcamStatus) {
    this.setState({ webcamStatus });
  }

  render() {
    const { webcamStatus, webcamDimensions } = this.state;
    const { closeWebcam, captureImage, example } = this.props;

    let webcamOverlay1 = {};
    let webcamOverlay2 = {};
    let captureBottom = 20;
    if (webcamDimensions) {
      if (webcamDimensions.width / webcamDimensions.height > 0.75) {
        const overlayWidth = (webcamDimensions.width - (webcamDimensions.height * 0.75)) / 2;

        webcamOverlay1 = {
          width: overlayWidth,
          height: webcamDimensions.height,
          top: 0,
          left: 0,
        };

        webcamOverlay2 = {
          width: overlayWidth,
          height: webcamDimensions.height,
          top: 0,
          right: 0,
        };
      } else {
        const overlayHeight = (webcamDimensions.height - ((webcamDimensions.width * 100) / 75)) / 2;

        captureBottom += overlayHeight;

        webcamOverlay1 = {
          width: webcamDimensions.width,
          height: overlayHeight,
          top: 0,
          left: 0,
        };

        webcamOverlay2 = {
          width: webcamDimensions.width,
          height: overlayHeight,
          bottom: 0,
          left: 0,
        };
      }
    }

    const capture = (getScreenshot) => {
      if (webcamStatus === null) {
        return (<div>{get(translations, 'txt: Veido savienojumu ar kameru ...', '')}</div>);
      }

      if (!webcamStatus) {
        return (<div>{get(translations, 'txt: Neizdevās pieslēgties kamerai', '')}</div>);
      }

      return (
        <div className="webcam-captureContainer" style={{ bottom: captureBottom }}>
          <span
            className="webcam-capture"
            role="button"
            tabIndex="0"
            onClick={() => captureImage(getScreenshot())}
            onKeyDown={() => captureImage(getScreenshot())}
          />
        </div>
      );
    };

    return (
      <div className={`verification-webcam dib${!webcamStatus ? ' webcam-status' : ''}`}>
        <Webcam
          ref={this.webcamVideo}
          audio={false}
          height={!webcamStatus ? 0 : 'auto'}
          width="100%"
          screenshotFormat="image/jpeg"
          onUserMedia={() => this.setWebcamStatus(true)}
          onUserMediaError={() => this.setWebcamStatus(false)}
        >
          {({ getScreenshot }) => capture(getScreenshot)}
        </Webcam>
        {webcamStatus && (
          <div>
            <img className="memberImage-item webcam-preview" src={example} alt="" />
            <div className="webcam-frameSide" style={webcamOverlay1} />
            <div className="webcam-frameSide" style={webcamOverlay2} />
          </div>
        )}
        <span
          className="webcam-close"
          role="button"
          tabIndex="0"
          onClick={closeWebcam}
          onKeyDown={closeWebcam}
        />
      </div>
    );
  }
}

VerificationWebcam.propTypes = {
  captureImage: PropTypes.func.isRequired,
  closeWebcam: PropTypes.func.isRequired,
  example: PropTypes.string,
};

VerificationWebcam.defaultProps = {
  example: '',
};

export default withResizeDetector(VerificationWebcam);
